/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersremovebody2Inputs */

const en_partnersremovebody2 = /** @type {(inputs: Partnersremovebody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The business stays as it is; it just no longer counts for this partner.`)
};

const de_partnersremovebody2 = /** @type {(inputs: Partnersremovebody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Betrieb ändert sich nichts, er zählt nur nicht mehr für diesen Partner.`)
};

/**
* | output |
* | --- |
* | "The business stays as it is; it just no longer counts for this partner." |
*
* @param {Partnersremovebody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersremovebody2 = /** @type {((inputs?: Partnersremovebody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersremovebody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersremovebody2(inputs)
	return de_partnersremovebody2(inputs)
});
export { partnersremovebody2 as "partnersRemoveBody" }